import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { UpdateMission } from '../../../store/actions/mission.actions';
import { Store } from '@ngrx/store';
import { LineInterface } from '../../../../lines/models/line.interface';

@Component({
    selector: 'app-cancel-change-network',
    templateUrl: './cancel-change-network.component.html',
    styleUrls: ['./cancel-change-network.component.css'],
    standalone: false
})
export class CancelChangeNetworkComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  portabilityDate: string;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.portabilityDate = null;
    this.formSubmitted = false;
    const explodePortabilityDate = this.line.statusDetails.portabilityDate.split(' ');
    if (explodePortabilityDate.length === 2) {
      this.portabilityDate = explodePortabilityDate[0];
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new UpdateMission(
          {
            step: 1,
            phoneNumber: this.line.phoneNumber,
            confirmation: true,
          },
          this.procedureCode
      ));
    }
  }
}
